import {memo} from "react";
import {cn} from "@/lib/utils";

interface CardImageZoomInProps {
    title: string;
    image: string;
    className?: string;
}
function CardImageZoomIn({title, className, image}: Readonly<CardImageZoomInProps>) {
    return (<div className={cn("group relative shadow bg-center bg-cover overflow-hidden", className)}>
        <div className={cn("absolute p-8 bg-center bg-cover z-0 w-full h-full group-hover:scale-150 transition-all duration-[200]")} style={{backgroundImage: `url('${image}')`}} />
        <div className="absolute w-full h-[100px] flex items-center justify-center bg-black/[.5] text-white font-exo bottom-0 left-0 z-10">{title}</div>
    </div>)
}

export default memo(CardImageZoomIn);
